import { createAction } from '@reduxjs/toolkit';

import type { Project, ProjectSaveParams } from '.';
import type { PickRequired } from 'types/common_types';

type UpdateProjectParams = PickRequired<ProjectSaveParams, 'guid' | 'id'>;

const getAll = {
  pending: createAction('projects/getAll/pending'),
  fulfilled: createAction<Project[]>('projects/getAll/fulfilled'),
  rejected: createAction('projects/getAll/rejected'),
};

const create = {
  pending: createAction<ProjectSaveParams>('projects/createProject/pending'),
  fulfilled: createAction<string>('projects/createProject/fulfilled'),
  rejected: createAction('projects/createProject/rejected'),
};

const update = {
  pending: createAction<UpdateProjectParams>('projects/update/pending'),
  fulfilled: createAction<UpdateProjectParams>('projects/update/fulfilled'),
  rejected: createAction('projects/update/rejected'),
};

const restore = {
  pending: createAction<string>('projects/restore/pending'),
  fulfilled: createAction('projects/restore/fulfilled'),
  rejected: createAction('projects/restore/rejected'),
};

const destroy = {
  pending: createAction<Project>('projects/destroy/pending'),
  fulfilled: createAction<number>('projects/destroy/fulfilled'),
  rejected: createAction('projects/destroy/rejected'),
};

export default { getAll, create, update, restore, destroy };
